import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const StatisticalAPI = {
  getSubmissionsSummary: function ({ org_id, start, end, integration_id = [], user_id = [], folder_id = [] }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/submissions-summary`,
      params: {
        start,
        end,
        integration_id: integration_id.join(','),
        user_id: user_id.join(','),
        folder_id: folder_id.join(','),
      },
    })
  },
  getStatisticsByDay: function ({ org_id, start, end, integration_id, user_id, folder_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/submissions-agg-day`,
      params: {
        start,
        end,
        integration_id: integration_id.join(','),
        user_id: user_id.join(','),
        folder_id: folder_id.join(','),
      },
    })
  },
  getStatisticsByWeek: function ({ org_id, start, end, integration_id, user_id, folder_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/submissions-agg-week`,
      params: {
        start,
        end,
        integration_id: integration_id.join(','),
        user_id: user_id.join(','),
        folder_id: folder_id.join(','),
      },
    })
  },
  getStatisticsByMonth: function ({ org_id, start, end, integration_id, user_id, folder_id  }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/submissions-agg-month`,
      params: {
        start,
        end,
        integration_id: integration_id.join(','),
        user_id: user_id.join(','),
        folder_id: folder_id.join(','),
      },
    })
  },
}
const cancelTokenObject = createCancelToken(StatisticalAPI)
export default StatisticalAPI
